export default "__VITE_ASSET__DxTeCDnf__"